import { useState } from 'react';
import Reveal from '@/components/base/Reveal';
import { faqs } from '@/mocks/home';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50">
      <div className="max-w-screen-xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4">
            <Reveal>
              <span className="inline-flex items-center gap-2 text-secondary-700 text-xs md:text-sm font-bold tracking-wide">
                <i className="ri-question-answer-line"></i>
                常见问题
              </span>
              <h2 className="mt-3 font-heading font-black text-2xl md:text-4xl text-foreground-950 tracking-tight">
                关于黑料福利，你可能想问
              </h2>
              <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                更新频率、话题排序、内容规范……先把最常被问到的几件事讲清楚，省得你在社区里反复打听。
              </p>
              <div className="mt-6 flex items-center gap-3 bg-secondary-50 border border-secondary-200 rounded-lg p-4">
                <span className="w-10 h-10 rounded-md bg-secondary-500 text-background-50 flex items-center justify-center shrink-0">
                  <i className="ri-mail-send-line text-xl"></i>
                </span>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  没找到答案？在话题墙发一条，会有热心网友和小编一起回复你。
                </p>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-8">
            <div className="flex flex-col gap-3">
              {faqs.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <Reveal key={item.q} delay={index * 60}>
                    <div
                      className={`bg-background-100 border rounded-lg overflow-hidden transition-colors ${
                        isOpen ? 'border-primary-300' : 'border-background-200'
                      }`}
                    >
                      <button
                        type="button"
                        onClick={() => setOpenIndex(isOpen ? null : index)}
                        className="cursor-pointer w-full flex items-center justify-between gap-4 px-5 py-4 text-left"
                        aria-expanded={isOpen}
                      >
                        <span className="font-heading font-bold text-sm md:text-base text-foreground-950">
                          {item.q}
                        </span>
                        <span
                          className={`shrink-0 w-7 h-7 rounded-full flex items-center justify-center transition-colors ${
                            isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'
                          }`}
                        >
                          <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'}></i>
                        </span>
                      </button>
                      {isOpen && (
                        <div className="px-5 pb-5 -mt-1">
                          <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                        </div>
                      )}
                    </div>
                  </Reveal>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}